import type { Maybe } from '@swf/generated/graphql/scoreboards/schemas';

export const formatEventStatusDuration = (
  intervalInSeconds: Maybe<number> | number | undefined,
  prefix = ' - ',
  suffix = '’'
) => {
  if (!intervalInSeconds) return '';
  const minutes = Math.floor(intervalInSeconds / 60);

  return `${prefix}${minutes}${suffix}`;
};
